import { render } from "./BookingFormRoom.vue?vue&type=template&id=7807832f&scoped=true"
import script from "./BookingFormRoom.vue?vue&type=script&lang=js"
export * from "./BookingFormRoom.vue?vue&type=script&lang=js"

import "./BookingFormRoom.vue?vue&type=style&index=0&id=7807832f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7807832f"]])

export default __exports__